import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const governanceProjectsConflictsRoute: InvariantJiraRoute = {
	name: 'governance-projects-conflicts',
	path: '/jira/settings/projects/policies/:policyId/conflicts',
	exact: true,
};
